import { AccountStub } from "protogen/common_pb";
import { RematchSession } from "protogen/advisors_service_pb";
import { AssignmentCandidate } from "protogen/signup_service_pb";

export const isNewAdvisor = (candidate: AssignmentCandidate): boolean =>
  candidate.advisor?.families?.length === 0 &&
  (candidate.deactivatedFamiliesCount ?? 0) === 0;

export const getAdvisorDisplayName = (advisor?: AccountStub): string =>
  advisor?.displayName || `${advisor?.firstName} ${advisor?.lastName}`;

export const CLIENT_EMAIL_SUBJECT = "Meet your New Advisor!";

export const generateClientEmail = (
  rematchSession: RematchSession,
  advisor: AccountStub,
  senderName: string,
): { text: string; html: string } => {
  const family = rematchSession.family;
  const clientName = family?.familyMembers?.[0]?.firstName || "there";
  const advisorName = getAdvisorDisplayName(advisor);
  const profileUrl = advisor.profilePath || "";

  const paragraphs = (advisorReference: string) => [
    `Hi ${clientName},`,
    "We know how important it is to have an Advisor who knows you and your family, and we want to make sure you continue feeling well taken care of!",
    `We've found a wonderful new Advisor for you, ${advisorReference}, who is excited to jump in and help. We'll work behind the scenes to get them up to speed on your account and outstanding tasks, so you don't have to start from scratch. And of course, none of that transition time will count toward your monthly hours.`,
    "We also know it can take a little time to find your rhythm with someone new, so we've added a $50 credit toward your next month as a thank-you for your flexibility.",
    `We're excited for you to get to know ${advisorName} and hope this is the start of another great relationship. If you have any questions or concerns about the transition, please don't hesitate to reach out.`,
    `Many thanks,\n${senderName}`,
  ];

  const text = paragraphs(`${advisorName} (${profileUrl})`).join("\n\n");
  const html = paragraphs(`<a href="${profileUrl}">${advisorName}</a>`)
    .map((paragraph) => paragraph.replace("\n", "<br>"))
    .join("<br><br>");

  return { text, html };
};
